import { z } from "zod";
import { commentTargetSchema } from "../comment/models.js";

export default {
  params: z.object({
    accountId: z.string(),
    targets: z.array(commentTargetSchema).min(1).max(2),
  }),
  response: z.void(),
};
